var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGPay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0036 10.223C20.0036 9.54246 19.947 8.86194 19.8336 8.19531H10.2109V12.0423H15.7238C15.497 13.2784 14.7601 14.3894 13.683 15.0838V17.5837H16.9709C18.8982 15.8477 20.0036 13.2784 20.0036 10.223Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2062 19.9989C12.9555 19.9989 15.2797 19.1101 16.9661 17.5824L13.6783 15.0825C12.7571 15.6936 11.5809 16.0408 10.2062 16.0408C7.54191 16.0408 5.28859 14.277 4.4808 11.916H1.09375V14.4992C2.82271 17.874 6.35148 19.9989 10.2062 19.9989Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.48183 11.9181C4.05668 10.682 4.05668 9.33487 4.48183 8.08494V5.51562H1.09477C-0.364924 8.33492 -0.364924 11.6681 1.09477 14.4874L4.48183 11.9181Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2062 3.95873C11.6659 3.93096 13.0689 4.47259 14.1176 5.45865L17.037 2.59769C15.1805 0.903335 12.7429 -0.0271719 10.2062 0.000604427C6.35148 0.000604427 2.82271 2.13938 1.09375 5.51421L4.4808 8.09741C5.2886 5.72253 7.54191 3.95873 10.2062 3.95873Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGPay);
export default __webpack_public_path__ + "static/media/GPay.c05030a401f61ee14bbdc097f3f25dae.svg";
export { ForwardRef as ReactComponent };